import React from "react";
import "./radio-button.scss";

export interface RadioButtonOption {
  label: string;
  value: string;
  disabled?: boolean;
}

export interface RadioButtonProps {
  name: string;
  options: RadioButtonOption[];
  value?: string;
  onChange?: (
    value: string,
    event: React.ChangeEvent<HTMLInputElement>
  ) => void;
  disabled?: boolean;
  className?: string;
  direction?: "vertical" | "horizontal";
  gap?: string;
  selectedColor?: string;
}

export const RadioButton: React.FC<RadioButtonProps> = ({
  name,
  options,
  value,
  onChange,
  disabled = false,
  className = "",
  direction = "vertical",
  gap,
  selectedColor,
}) => {
  const handleChange = (
    optionValue: string,
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (!disabled) {
      onChange?.(optionValue, e);
    }
  };

  const containerStyle: React.CSSProperties = {
    display: "flex",
    flexDirection: direction === "vertical" ? "column" : "row",
    gap: gap ?? (direction === "vertical" ? "0.75rem" : "1rem"),
    ...(selectedColor ? { "--radio-selected-color": selectedColor } as React.CSSProperties : {}),
  };

  return (
    <div className={`radio-button-group ${className}`} style={containerStyle} role="radiogroup">
      {options.map((option) => {
        const isDisabled = disabled || option.disabled;
        const isChecked = value === option.value;
        const id = `${name}-${option.value}`;

        return (
          <label
            key={option.value}
            className={`radio-button ${isDisabled ? "radio-button--disabled" : ""}`}
            htmlFor={id}
          >
            <input
              className="radio-button__input"
              type="radio"
              id={id}
              name={name}
              value={option.value}
              checked={isChecked}
              onChange={(e) => handleChange(option.value, e)}
              disabled={isDisabled}
            />
            <span className="radio-button__circle">
              <span className="radio-button__outer" />
              <span className="radio-button__dot" />
            </span>
            <span className="radio-button__label">{option.label}</span>
          </label>
        );
      })}
    </div>
  );
};
